import {
  Component,
  inject,
  OnInit,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ProductsListState } from '@core/store/products/products.state';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { DataTableComponent } from '@shared/components/data-table/data-table.component';
import {
  DataTableConfiguration,
  DataTableSelectionType,
} from '@shared/components/data-table/data-table.types';
import { map } from 'rxjs';

@Component({
  selector: 'app-bundle-list-dialog',
  imports: [DataTableComponent, TranslatePipe],
  templateUrl: './bundle-list-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './bundle-list-dialog.component.scss',
})
export class BundleListDialogComponent implements OnInit {
  public bundleIds = signal<string[]>(null);

  protected modalRef = inject(NgbActiveModal);
  private store = inject(Store);

  protected tableConfiguration: DataTableConfiguration;

  ngOnInit(): void {
    this.tableConfiguration = {
      title: '',
      selectionMode: DataTableSelectionType.NONE,
      tableHeadClasses: '',
      columns: [
        {
          label: 'pricing.discount.list.columns.bundleName',
          property: 'internalName',
        },
      ],
      rows$: this.store
        .select(ProductsListState.getBundlesList)
        .pipe(
          map((bundlesList) =>
            bundlesList.filter((bundle) => this.bundleIds().includes(bundle.id))
          )
        ),
    };
  }
}
